<template>
  <div
    id="select-token-modal"
    :width="527"
    scroll="keep"
    class="modal-card bd-rd"
    @close="$emit('close')"
  >
    <div class="is-expanded">
      <div class="modal-header">
        {{ $t('exchange.select_token') }}
      </div>
      <div
        class="modal-header-close-btn"
        @click="$parent.close()"
      >
        <img src="/static/svg/close-symbol.svg">
      </div>
      <div class="modal-container">
        <div class="is-expanded pd-30px-bt0px">
          <div class="input-search">
            <b-input
              ref="search"
              v-model="searchInput"
              :placeholder="$t('exchange.select_token_placeholder')"
              type="search"
              icon="search"
              class="is-underline-input-gray"
            />
            <img
              src="/static/svg/search.svg"
              class="ic-search"
            >
          </div>
        </div>
        <div class="tokens-list-box">
          <div
            v-if="tokens.length"
            class="columns is-multiline is-mobile"
          >
            <div
              v-for="(token, i) in tokensFiltered"
              :key="i"
              class="column is-one-third-tablet is-half-mobile"
              @click="selectToken(token)"
            >
              <div :class="['token-item', { 'border-token-select': tokenSelectedCode === token.code }]">
                <TokenItem
                  :img="token.code"
                  :code="token.code"
                  :name="token.name"
                  :balance="token.balance"
                />
              </div>
            </div>
          </div>
          <div v-else>
            Loading...{{ tokens.length }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TokenItem from './TokenItem'

export default {
  name: 'SelectTokenModal',
  components: {
    TokenItem
  },
  props: {
    tokens: {
      type: [Object, Array],
      default: () => []
    },
    tokenSelectedCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      searchInput: null
    }
  },
  computed: {
    sortTokenByUsdValue () {
      if (this.tokens.length) {
        const codeEth = 'ETH'
        const tokens = this.tokens.slice(0)
        const result = tokens.sort((first, sec) => {
          if (sec.code === codeEth) {
            return 1
          } else if (first.code === codeEth) {
            return -1
          } else {
            return sec.usdValue - first.usdValue
          }
        })
        return result
      } else {
        return []
      }
    },
    tokensFiltered () {
      if (this.searchInput) {
        return this.sortTokenByUsdValue.filter(t => t.code.toLowerCase().match(this.searchInput.toLowerCase()) || t.name.toLowerCase().match(this.searchInput.toLowerCase()))
      } else {
        return this.sortTokenByUsdValue
      }
    }
  },
  mounted () {
    this.$refs.search.focus()
  },
  methods: {
    selectToken (token) {
      this.$emit('select', token)
      this.$emit('close')
    }
  }
}
</script>

<style>
#select-token-modal .modal-content {
  overflow: hidden;
}
</style>

<style scoped>
.bd-rd {
  border-radius: 5px;
}
.modal-header {
  float: left;
  width: 100%;
  background-color: #0559af;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  text-align: center;
  padding: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}
.modal-container {
  float: left;
  width: 100%;
  background-color: #fff;
}
.pd-30px-bt0px {
  padding: 30px 30px 0 30px;
}
.input-search {
  position: relative;
}
.ic-search {
  position: absolute;
  top: 8px;
  left: 7px;
}
.tokens-list-box {
  float: left;
  width: 100%;
  margin-top: 25px;
  color: #333333;
  height: 70vh;
  overflow: auto;
  padding: 0 30px 30px 30px;
}
.token-item {
  float: left;
  width: fit-content;
  padding: 12px;
  width: 100%;
}
.token-item:hover {
  background-color: #fbfbfb;
  cursor: pointer;
}
.border-token-select {
  border-radius: 2px;
  border: solid 2px #0096ed;
}
.modal-header-close-btn {
  position: absolute;
  top: 15px;
  right: 19px;
}
.modal-header-close-btn:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectTokenModal.vue